import "./Products.css";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import Quantity from "./Quantity";

function ProductThumb({ product }) {
  const [imageIsLoaded, setImageIsLoaded] = useState(false);

  return (
    <>
      <Card className="shadow mb-3">
        <Link key={product.slug} to={`/producto/${product.slug}`}>
          <Card.Body>
            <div className="row d-flex justify-content-center align-items-center">
              {!imageIsLoaded && (
                <div
                  className="row d-flex justify-content-center align-items-center"
                  style={{ height: "10rem" }}
                >
                  <Spinner
                    animation="border"
                    role="info"
                    style={{ color: "rgb(119, 33, 33)" }}
                  ></Spinner>
                </div>
              )}

              <img
                className="img-fluid"
                style={{ height: "10rem", objectFit: "cover" }}
                src={`${product.picture}`}
                alt={product.name}
                onLoad={() => setImageIsLoaded(true)}
              />
            </div>
          </Card.Body>
        </Link>
        <Card.Footer className="text-muted text-center">
          <div
            className="row ps-2 pe-2 d-flex justify-content-center align-items-center"
            style={{ fontSize: "0.7rem", height: "3rem" }}
          >
            {product.name}
          </div>
          <Quantity product={product} />
        </Card.Footer>
      </Card>
    </>
  );
}

export default ProductThumb;
